<template>
  <div>
    <Loader v-if="loading"/>
    <div v-else class="app-main-layout">
    
    <Navbar @click="isOpen = !isOpen" />

    <Sidebar v-model="isOpen" :key="locale" />
    
    <main class="app-content" :class="{full: !isOpen}">
      <div class="app-page">
        <router-view />
      </div>
    </main>

    <div class="fixed-action-btn">
      <router-link 
      :key={mess}
      class="btn-floating btn-large blue" 
      to="/record"
      v-tooltip="mess"
      >
        <i class="large material-icons">add</i>
      </router-link>
    </div>
  </div>
  </div>
  
</template>

<script>
import Navbar from '@/components/app/Navbar'
import Sidebar from '@/components/app/Sidebar'
import messages from '@/utils/messages'
import localizeFilter from '@/filters/localize.filter'
export default {
  name: 'main-layout',
  data: () => ({
    isOpen: true,
    loading: true,
    //tooltip: ''
  }),

  async mounted(){
    
      //this.tooltip = localizeFilter('Create_New_Rec')
      if(!Object.keys(this.$store.getters.info).length) {
        await this.$store.dispatch('fetchInfo')
      }
      this.loading = false
  },

  components: {
    Navbar, Sidebar
  },
  computed:{
    mess() {return localizeFilter('Create_New_Rec')},
    error(){
      return this.$store.getters.error
    },
    locale() {
      return this.$store.getters.info.locale
    }
  },
  watch: {
    error(fbError){
      console.log('Firebase Error',fbError)
      this.$error(messages[fbError.code] || 'Что-то пошло не так...')
      console.log(messages)
    }
  }
}
</script>
